import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const MembersPage = lazy(() =>
  import('./pages/MembersPage').then(m => ({ default: m.MembersPage }))
);

/** Member directory — admin/teacher only (mirrors GET /api/members/). */
export const memberRoutes = (
  <Route element={<RequireRole roles={['admin', 'teacher']} />}>
    <Route path="/members" element={<MembersPage />} />
  </Route>
);
